import client from './client';

/**
 * The listed price of one made-to-order formulation.
 *
 * Held in the ecommerce service's app_settings, not in a deploy config, so the
 * price can move on the business's timetable. `mrp` is the struck-through "was"
 * price and is null unless one has genuinely been set — the storefront hides its
 * launch-offer card entirely rather than advertise a saving against nothing.
 */
export interface FormulationPricing {
  price: number;
  mrp: number | null;
  has_discount: boolean;
  discount_amount: number;
  currency: string;
  /** When the price was last changed, and by which admin (audit trail). */
  updated_at: string | null;
  updated_by: string | null;
}

export async function getFormulationPricing(): Promise<FormulationPricing> {
  const res = await client.get('/api/admin/pricing/formulation');
  return res.data as FormulationPricing;
}

/** Both values are always sent — `mrp: null` clears the struck-through price. */
export async function updateFormulationPricing(
  price: number,
  mrp: number | null,
): Promise<FormulationPricing> {
  const res = await client.put('/api/admin/pricing/formulation', { price, mrp });
  return res.data as FormulationPricing;
}
